// src/components/WelcomePage.js
import React, { useState, useEffect } from 'react';
import { apiFetchPublicCompanyInfo } from '../api/CompanySidebarApi'; // Adjust import path if needed
import './WelcomePage.css';
import LoadingComponent from './LoadingComponent'; // Assuming you have a loading spinner

const WelcomePage = () => {
  const [companyInfo, setCompanyInfo] = useState(null); // { companyName, logoUrlToDisplay }
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [logoLoadError, setLogoLoadError] = useState(false); // Track image loading errors

  useEffect(() => {
    const fetchInfo = async () => {
      setIsLoading(true);
      setError(null);
      setLogoLoadError(false);
      console.log('[WelcomePage] Fetching public company info...');
      try {
        const result = await apiFetchPublicCompanyInfo();
        if (result.status && result.data) {
          console.log('[WelcomePage] Received company info:', result.data);
          setCompanyInfo(result.data);
        } else {
          console.warn(
            '[WelcomePage] Failed to fetch company info or no data found:',
            result.message,
          );
          // Don't set an error for simply 'not found', just show defaults
          if (result.error && result.status !== 404) {
            // Set error for actual fetch errors
            setError(result.message || 'Could not load company information.');
          }
          setCompanyInfo(null); // Ensure info is null if fetch fails or empty
        }
      } catch (err) {
        console.error('[WelcomePage] Unexpected error fetching info:', err);
        setError('An unexpected error occurred.');
        setCompanyInfo(null);
      } finally {
        setIsLoading(false);
      }
    };

    fetchInfo();
  }, []); // Empty dependency array means run once on mount

  const handleLogoError = () => {
    console.warn('[WelcomePage] Failed to load company logo image.');
    setLogoLoadError(true); // Set flag to hide broken image icon
  };

  // --- Render Logic ---
  const companyName = companyInfo?.companyName;
  const logoUrl = companyInfo?.logoUrlToDisplay;
  const headingText = `Welcome to the Influencers Relationship Management System!`;

  if (isLoading) {
    return <LoadingComponent message="Loading..." />;
  }

  // Optional: Display fetch error
  // if (error) {
  //     return <div className="welcome-page error-message">Error: {error}</div>;
  // }

  return (
    <div className="welcome-page">
      {/* Conditionally render logo if URL exists and no load error */}
      {logoUrl && !logoLoadError && (
        <img
          src={logoUrl}
          alt={companyName ? `${companyName} Logo` : 'Company Logo'}
          className="welcome-logo"
          onError={handleLogoError} // Handle image load failures
        />
      )}
      <h2>{headingText}</h2>
      <p>Please login or Signup to start a new session.</p>
    </div>
  );
};

export default WelcomePage;
